export default __webpack_public_path__ + "static/media/icon-uiux-testing.ebff6e96.svg";